export const colorTheme = {
  primary: "#00A0E1",
  primaryDark: "#005591",
  grayDark: "#6E7878",
  gray: "#d5d5d5",
  light: "#fff",
  error: "#910000",
  warning: "#DC7800",
  success: "#55c018",
};
